import { render, staticRenderFns } from "./TabGuestDocumentation.vue?vue&type=template&id=452d327c&"
import script from "./TabGuestDocumentation.vue?vue&type=script&lang=js&"
export * from "./TabGuestDocumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports